module.exports = {
  TOP: 64,
  LEFT_PANEL_WIDTH: 400,
  SEARCH_DISTANCE: 1500 /* meters */,
  SEARCH_BOX_WIDTH: 325
};
